import { render, staticRenderFns } from "./NewsAndUpdates.vue?vue&type=template&id=5c4c7ab6&scoped=true"
import script from "./NewsAndUpdates.vue?vue&type=script&lang=js"
export * from "./NewsAndUpdates.vue?vue&type=script&lang=js"
import style0 from "./NewsAndUpdates.vue?vue&type=style&index=0&id=5c4c7ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c7ab6",
  null
  
)

export default component.exports